import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  Modal,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import VideoIcon from "@mui/icons-material/VideoLibrary";
import DescriptionIcon from "@mui/icons-material/Description";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import { db, storage } from "../../../Firebase/FirebaseConfig"; // Assuming Firebase is properly initialized
import moment from "moment";
import { child, increment, push, ref, set, update } from "firebase/database";
import {
  getDownloadURL,
  uploadBytes,
  ref as storageRef,
} from "firebase/storage";
import toast from "react-hot-toast";

const FormMessageCategories = ({
  selectedCategories, // Selected categories instead of selected users
  handleClose,
  loginProfile,
  selectedName,
}) => {
  const [openPreview, setOpenPreview] = useState(false);
  const [message, setMessage] = useState("");
  const [topic, setTopic] = useState("");
  const [topicError, setTopicError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [fileError, setFileError] = useState("");
  const [selectedOption, setSelectedOption] = useState("Text");
  const [file, setFile] = useState(null);

  const handleSend = async () => {
    if (selectedCategories.length === 0) {
      toast.error("No members are present in this category");
      handleClose();
      return;
    }


    const OwnId = loginProfile?._id;
    if (!OwnId) {
      console.error("User ID is missing");
      return;
    }

    if (selectedOption.toLowerCase() === "text") {
      try {
        let sendMessageAdmin = {
          content: message,
          senderID: OwnId,
          receiverID: "",
          timestamp: moment().format("MMMM DD, YYYY"),
          time: moment().format("HH:mm"),
          dateTime: moment().format(),
          seen: false,
          type: selectedOption.toLowerCase(),
          userName: "Admin",
        };

        for (const categoryId of selectedCategories) {
          const receiverID = [OwnId, categoryId].sort().join("-");
          const chatroomRef = ref(db, `chatrooms/${receiverID}`);
          const messagesRef = child(chatroomRef, "messages");
          sendMessageAdmin.receiverID = categoryId;

          const newMessageRef = push(messagesRef);
          await set(newMessageRef, sendMessageAdmin);

          const updates = {};
          updates[`chatList/${OwnId}/${categoryId}/chatroomID`] = receiverID;
          updates[`chatList/${OwnId}/${categoryId}/lastMessage`] =
            sendMessageAdmin.content;
          updates[`chatList/${OwnId}/${categoryId}/lastMessageTimestamp`] =
            sendMessageAdmin.dateTime;
          updates[`chatList/${OwnId}/${categoryId}/lastMessaged`] = OwnId;
          updates[`chatList/${OwnId}/${categoryId}/seenCount`] = 0;
          updates[`chatList/${OwnId}/${categoryId}/type`] = "text";

          updates[`chatList/${categoryId}/${OwnId}/chatroomID`] = receiverID;
          updates[`chatList/${categoryId}/${OwnId}/lastMessage`] =
            sendMessageAdmin.content;
          updates[`chatList/${categoryId}/${OwnId}/lastMessageTimestamp`] =
            sendMessageAdmin.dateTime;
          updates[`chatList/${categoryId}/${OwnId}/lastMessaged`] = OwnId;
          updates[`chatList/${categoryId}/${OwnId}/seenCount`] = increment(1);
          updates[`chatList/${categoryId}/${OwnId}/type`] = "text";
          updates[`chatList/${categoryId}/${OwnId}/userName`] = "Admin";
          updates[`chatList/${categoryId}/${OwnId}/remoteId`] = OwnId;

          await update(ref(db), updates);
        }

        toast.success("Message sent");

        setOpenPreview(false);
        handleClose();
        setMessage("");
        setTopic("");
        setFile(null);
        setSelectedOption("Text");
        setTopicError("");
        setMessageError("");
        setFileError("");
        // setSelectedCategories([]);
      } catch (error) {
        console.error("Error sending message:", error);
      }
    } else {
      if (!file) return;

      try {
        for (const categoryId of selectedCategories) {
          const receiverID = [OwnId, categoryId].sort().join("-");

          const fileStorageRef = storageRef(
            storage,
            `uploads/${OwnId}/${file.name}`
          );
          const snapshot = await uploadBytes(fileStorageRef, file, {
            contentType: "application/octet-stream",
          });
          const downloadURL = await getDownloadURL(fileStorageRef);

          const fileData = {
            content: file.name,
            senderID: OwnId,
            receiverID: categoryId,
            timestamp: moment().format("MMMM DD, YYYY"),
            time: moment().format("HH:mm"),
            dateTime: moment().format(),
            type: file.type.startsWith("image/")
              ? "image"
              : file.type.startsWith("video/")
              ? "video"
              : "file",
            fileUrl: downloadURL,
          };

          const chatroomRef = ref(db, `chatrooms/${receiverID}`);
          const messagesRef = child(chatroomRef, "messages");

          const newMessageRef = push(messagesRef);
          await set(newMessageRef, fileData);

          const updates = {};
          updates[`chatList/${OwnId}/${categoryId}/chatroomID`] = receiverID;
          updates[`chatList/${OwnId}/${categoryId}/lastMessage`] =
            fileData.content;
          updates[`chatList/${OwnId}/${categoryId}/lastMessageTimestamp`] =
            fileData.dateTime;
          updates[`chatList/${OwnId}/${categoryId}/lastMessaged`] = OwnId;
          updates[`chatList/${OwnId}/${categoryId}/seenCount`] = 0;
          updates[`chatList/${OwnId}/${categoryId}/type`] = fileData.type;

          updates[`chatList/${categoryId}/${OwnId}/chatroomID`] = receiverID;
          updates[`chatList/${categoryId}/${OwnId}/lastMessage`] =
            fileData.content;
          updates[`chatList/${categoryId}/${OwnId}/lastMessageTimestamp`] =
            fileData.dateTime;
          updates[`chatList/${categoryId}/${OwnId}/lastMessaged`] = OwnId;
          updates[`chatList/${categoryId}/${OwnId}/seenCount`] = increment(1);
          updates[`chatList/${categoryId}/${OwnId}/type`] = fileData.type;
          updates[`chatList/${categoryId}/${OwnId}/fileUrl`] = fileData.fileUrl;

          await update(ref(db), updates);
        }
        toast.success("Message sent");
        setOpenPreview(false);
        handleClose();
        setMessage("");
        setTopic("");
        setFile(null);
        setSelectedOption("Text");
        setTopicError("");
        setMessageError("");
        setFileError("");
        // setSelectedCategories([]);
      } catch (error) {
        console.error("Error sending file:", error);
      }
    }
  };

  const handlePreview = () => {
    if (selectedOption === "Text" && !message) {
      setMessageError("Message is required.");
      return;
    } else {
      setMessageError("");
    }

    if (selectedOption !== "Text" && !file) {
      setFileError("File is required.");
      return;
    } else {
      setFileError("");
    }

    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const handleSendMessage = () => {
    handleSend();
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setMessage("");
    setFile(null);
    setFileError("");
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileError("");
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "40vw", // Adjust the width
          height: "auto",
          mx: "auto",
          mt: 2,
          p: 3,
          border: "1px solid #ccc",
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6">Selected</Typography>
        <TextField
          variant="filled"
          fullWidth
          label="Selected Category"
          value={selectedName}
          InputProps={{
            readOnly: true,
          }}
        />

        <Typography variant="h6">Select Message Type</Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Text">
            <IconButton
              color={selectedOption === "Text" ? "primary" : "default"}
              onClick={() => handleOptionSelect("Text")}
            >
              <TextFieldsIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Image">
            <IconButton
              color={selectedOption === "Image" ? "primary" : "default"}
              onClick={() => handleOptionSelect("Image")}
            >
              <ImageIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Video">
            <IconButton
              color={selectedOption === "Video" ? "primary" : "default"}
              onClick={() => handleOptionSelect("Video")}
            >
              <VideoIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Document">
            <IconButton
              color={selectedOption === "Document" ? "primary" : "default"}
              onClick={() => handleOptionSelect("Document")}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </Box>

        {/* File Input for selecting image/video/document */}
        {selectedOption !== "Text" && (
          <Box>
            <input
              accept={
                selectedOption === "Image"
                  ? "image/*"
                  : selectedOption === "Video"
                  ? "video/*"
                  : "application/pdf" // Assuming document is PDF
              }
              id="file-upload"
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <label htmlFor="file-upload">
              <Button
                variant="contained"
                component="span"
                color="primary"
                sx={{ marginTop: 2 }}
              >
                Select {selectedOption}
              </Button>
            </label>
            {file && (
              <Typography variant="body2" sx={{ marginTop: 1 }}>
                Selected: {file.name}
              </Typography>
            )}
            {fileError && (
              <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
                {fileError}
              </Typography>
            )}
          </Box>
        )}

        <Typography variant="h6">Message</Typography>
        {selectedOption === "Text" ? (
          <TextField
            variant="outlined"
            fullWidth
            label="Message"
            placeholder="Enter your message"
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)} // Update message state
            error={!!messageError} // Display error state
            helperText={messageError} // Display error message
          />
        ) : null}

        <Button variant="contained" color="primary" onClick={handleSendMessage}>
          Send Message
        </Button>
      </Box>

      {/* Preview Modal */}
      <Modal open={openPreview} onClose={handleClosePreview}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "300px",
            maxHeight: "80vh", // Set a maximum height
            bgcolor: "#e1ffc7", // Light green WhatsApp-style color
            boxShadow: 24,
            p: 2,
            borderRadius: "15px",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            position: "relative",
            overflowY: "auto", // Enable vertical scrolling
          }}
        >
          {/* Close Icon in the preview modal */}
          <IconButton
            onClick={handleClosePreview}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Preview message content */}
          <Box
            sx={{
              backgroundColor: "#fff", // WhatsApp chat bubble green
              padding: "10px 15px",
              borderRadius: "10px",
              borderTopRightRadius: "0px",
              boxShadow: 1,
              wordWrap: "break-word",
            }}
          >
            <Typography variant="body2" sx={{ mt: 1 }}>
              {message || (file && `File: ${file.name}`)}
            </Typography>
          </Box>

          {/* File preview */}
          {selectedOption !== "Text" && (
            <Box>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Selected File:
              </Typography>
              <Typography variant="body2">
                {file ? file.name : "No file selected"}
              </Typography>
            </Box>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={handleSendMessage}
            sx={{ alignSelf: "flex-end" }}
          >
            Send Message
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default FormMessageCategories;
